import dayjs from "dayjs";
import Lockr from "lockr";

const createKey = (public_key) => {
  return `test_start_${public_key}`;
};

export default {
  init: (public_key) => {
    const composedKey = createKey(public_key);
    const currentNow = dayjs();
    Lockr.set(composedKey, currentNow.format("YYYY-MM-DD HH:mm:ss"));
    console.log(
      "registering start of the test: ",
      currentNow.format("YYYY-MM-DD HH:mm:ss")
    );
  },
  end: (public_key) => {
    const composedKey = createKey(public_key);
    const currentNow = dayjs();
    console.log(
      "registering end of the test: ",
      currentNow.format("YYYY-MM-DD HH:mm:ss")
    );
    const init = Lockr.get(composedKey);
    const initTime = dayjs(init);
    let diff = initTime.diff(currentNow, "minute");
    if (diff == 0) diff = 1;
    return diff;
  },
};
